module.exports = __webpack_public_path__ + "cloud-optimization.1YVuvGcV.svg";